import { IListingFloorplans, IListingPhotos, ISuiteTypesFloorplans } from '@llws/lift-entity-interfaces';
import app from '@/main';

export const getNewUnitFloorplan = (
  clientId: number,
  buildingId: number,
  image: string,
  pdf: string | null,
  imageHeight: number,
  imageWidth: number,
  name: string,
  active: 0 | 1,
  suiteTypeId: number,
): ISuiteTypesFloorplans => ({
  clientId,
  buildingId,
  image,
  imageHeight,
  imageWidth,
  created: new Date(),
  createdUserId: parseInt(app()?.$rsGlobals.$currentUser.userId || '0', 10),
  active,
  pdf,
  name,
  orderBy: 0,
  suiteTypeId,
} as unknown as ISuiteTypesFloorplans);
